import "./styles.scss";
import React, { CSSProperties, useMemo } from "react";
import type KC_Colors from "../KC_Colors";
import { classNameForColor } from "../ds_commons";

export interface KC_SpanProps {
  id?: string;
  onClick?: () => void;
  text?: string;
  isBold?: boolean;
  isUnderlined?: boolean;
  href?: string;
  color?: KC_Colors;
  underlineColor?: KC_Colors;
  className?: string;
  hrefBlank?: boolean;
  isSemiBold?: boolean;
  img?: string;
  svg?: React.ReactNode;
  style?: CSSProperties;
}

export default function KC_Span(props: KC_SpanProps) {
  const style = useMemo(() => {
    return {
      ...(props.style || {}),
      cursor: !!props.onClick ? "pointer" : "unset"
    };
  }, [props.style]);
  return (
    <span
      id={props.id}
      className={`kc-link ${props.className || ""} 
      ${props.isBold ? "kc-link-bold" : ""} 
      ${props.isSemiBold ? "kc-link-semi-bold" : ""}
      ${
        props.isUnderlined
          ? `kc-link-underline ${
              props.underlineColor
                ? `${classNameForColor(props.underlineColor)} !important`
                : ""
            }`
          : ""
      } ${classNameForColor(props.color)}`}
      style={style}
      onClick={props.onClick}
    >
      {props.img && (
        <img
          src={props.img}
          alt="span-img"
          style={{ width: "100%", marginBottom: "1rem" }}
        />
      )}

      {props.svg && props.svg}
      {props.href ? (
        <a
          href={props.href}
          target={props.hrefBlank ? "_blank" : undefined}
          rel="noreferrer"
        >
          {props.text}
        </a>
      ) : (
        props.text
      )}
    </span>
  );
}
